module.exports = __webpack_public_path__ + "img/palette-1_fg_cn.06f4de4.jpg";